/******/ (() => { // webpackBootstrap
/*!*******************************************!*\
  !*** ./js/sections/brand-logos-slider.js ***!
  \*******************************************/
if (!customElements.get('brand-logos-slider')) {
  customElements.define('brand-logos-slider', class BrandLogosSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.brand-logos__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        pagination: '.swiper-pagination'
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper'
      };
      this.container = this.closest('.brand-logos__container');
      this.sectionContent = this.closest('.section__content');
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items) || 6;
      this.tabletItems = parseInt(this.dataset.tabletItems) || 3;
      this.laptopItems = parseInt(this.dataset.laptopItems) || 5;
      this.navigationPosition = this.dataset.navigationPosition || 'middle';
      this.sliderInstance = false;
      if (!this.enableSlider) return;
      var mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.onchange = this.init.bind(this);
      this.init();
    }
    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }
    initSlider() {
      if (typeof this.sliderInstance === 'object') return;
      var columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
      // const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10 || 16;
      var spaceBetween = 0;

      // Look for controls in section__content (parent of brand-logos__container)
      var controlsContainer = this.sectionContent || this.container;
      this.sliderOptions = {
        slidesPerView: 2,
        spaceBetween: spaceBetween,
        navigation: {
          nextEl: controlsContainer.querySelector(this.selectors.nextEl),
          prevEl: controlsContainer.querySelector(this.selectors.prevEl)
        },
        pagination: {
          el: controlsContainer.querySelector(this.selectors.pagination),
          type: 'progressbar'
        },
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems
          },
          1024: {
            slidesPerView: this.laptopItems
          },
          1280: {
            slidesPerView: this.items
          }
        },
        loop: false,
        threshold: 2,
        watchSlidesProgress: true
      };
      this.classList.add(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.grid);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);
      this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
      this.sliderInstance.init();
    }
    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  });
}
/******/ })()
;